/* eslint-disable jsx-a11y/accessible-emoji */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import CommentForm from '../Form/Comment';
import { withAuthentication } from '../Session';
import usePersistedState from '../../utils/usePersistedState';

const CommentItem = ({
  comment, sub, authUser, userData, firebase, handleNewComment,
}) => {
  const { t } = useTranslation();

  const [didVote, setVote] = usePersistedState(`didVoteComment-${comment.path}`, null);
  const [score, setScore] = useState(comment.score);
  const [replyVisible, setReplyVisible] = useState(false);

  const { path } = comment;

  const {
    dbFs,
    fieldValue,
    userCollection,
  } = firebase;

  const updateUserKarma = async () => {
    const { uid } = authUser;
    const userRef = userCollection.doc(uid);

    try {
      await userRef
        .update({
          karma: fieldValue.increment(1),
        });
    } catch (e) {
      console.log(e);
    }
  };

  const updateCommentScore = async () => {
    try {
      await dbFs
        .doc(path)
        .update({
          score: fieldValue.increment(1),
        });
      updateUserKarma();
      setVote(true);
      setScore(score + 1);
    } catch (e) {
      console.log(e.message);
    }
  };

  const renderCommentVotes = () => {
    if (userData) {
      if (userData.id !== comment.by && !didVote) {
        return (
          <>
            <button type="button" onClick={() => updateCommentScore()}>
              <span aria-label="upvote" role="img">⬆️</span>
            </button>
            <p aria-label="upvotes">{score}</p>
          </>
        );
      } if (userData.id === comment.by && !didVote) {
        return (
          <>
            <span aria-label="You created this item" role="img">📝</span>
            <p aria-label="upvotes">{score}</p>
          </>
        );
      } if (didVote) {
        return (
          <>
            <span aria-label="You upvoted this" role="img">⭐️</span>
            <p aria-label="upvotes">{score}</p>
          </>
        );
      }
    }
  };

  return (
    <div className={`comment-container ${sub ? 'sub-comment' : ''}`}>
      <div className="comment-header">
        {renderCommentVotes()}
        <p>{comment.by}</p>
        {t('comments.scorePoint', { count: score })}
      </div>
      <div className="comment-body">
        <p>{comment.text}</p>
      </div>
      <div className="comment-footer">
        {!replyVisible && authUser
        && (
        <button onClick={() => setReplyVisible(true)} className="btn" type="submit">
          {t('comments.reply')}
        </button>
        )}
        {replyVisible
        && (
        <CommentForm
          reply
          handleNewComment={handleNewComment}
          parent={path}
        />
        )}
      </div>
      {comment.comments ? (comment.comments.map((subComment) => (
        <CommentItem
          sub
          key={subComment.created}
          authUser={authUser}
          comment={subComment}
          firebase={firebase}
          handleNewComment={handleNewComment}
          userData={userData}
          parent={path}
        />
      )))
        : null}
    </div>
  );
};

CommentItem.propTypes = {
  firebase: PropTypes.object.isRequired,
  comment: PropTypes.shape({
    created: PropTypes.any,
    by: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    comments: PropTypes.array.isRequired,
    score: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired,
  }).isRequired,
  authUser: PropTypes.object.isRequired,
  userData: PropTypes.shape({
    about: PropTypes.string,
    created: PropTypes.element,
    id: PropTypes.string,
    karma: PropTypes.number,
    submitted: PropTypes.array,
  }),
  sub: PropTypes.bool,
  handleNewComment: PropTypes.func.isRequired,
};

export default withAuthentication(CommentItem);
